import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateFormEditorFormThunk } from 'scenes/Settings/FormEditor/store/thunks/formEditorThunks';
import {
  getEmployerBusinesses,
  getSelectedFormEditorForm,
  removeBusinessIdForTheForm,
  updateBusinessIdForTheForm,
} from '../../../store/slices/formEditorSlice';
import { SuggestionField } from './SuggestionField';
import Button from 'components/Button/Button';

export const BusinessIdToForm = () => {
  const { enqueueSnackbar } = useSnackbar();

  const dispatch = useDispatch();
  const selectedForm = useSelector(getSelectedFormEditorForm);
  const businesses = useSelector(getEmployerBusinesses);

  const [newBusinessId, setNewBusinessId] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [filteredBusinesses, setFilteredBusinesses] = useState([]);

  useEffect(() => {
    if (newBusinessId.trim() && businesses?.length > 0) {
      const filtered = businesses.filter(
        (business) =>
          business.business_id
            ?.toLowerCase()
            .includes(newBusinessId.toLowerCase()) &&
          !selectedForm?.businessId?.includes(business.business_id)
      );
      setFilteredBusinesses(filtered);
      setShowSuggestions(filtered.length > 0);
    } else {
      setShowSuggestions(false);
      setFilteredBusinesses([]);
    }
  }, [newBusinessId, businesses, selectedForm?.businessId]);

  useEffect(() => {
    if (!selectedForm?.id || !selectedForm?.name) return;
  }, [selectedForm]);

  const handleAddBusinessId = (businessId = null) => {
    const idToAdd = businessId || newBusinessId.trim();
    if (idToAdd) {
      console.log('IDS', selectedForm?.businessId);
      dispatch(updateBusinessIdForTheForm(idToAdd));

      setNewBusinessId('');
      setShowSuggestions(false);
    }
  };

  const handleSuggestionClick = (businessId) => {
    setNewBusinessId(businessId);
    setShowSuggestions(false);
  };

  const handleRemoveBusinessId = (id) => {
    dispatch(removeBusinessIdForTheForm(id));
  };

  const onUpdateFormEditorThunk = () => {
    enqueueSnackbar('Tallennettu onnistuneesti', { variant: 'success' });
    dispatch(updateFormEditorFormThunk());
  };

  return (
    <>
      {selectedForm?.id && (
        <main>
          <div style={{ position: 'relative' }}>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr auto',
                gap: 8,
              }}
            >
              {/* Business ID Input */}
              <input
                value={newBusinessId}
                onChange={(e) => setNewBusinessId(e.target.value)}
                onFocus={() =>
                  newBusinessId.trim() &&
                  setShowSuggestions(filteredBusinesses.length > 0)
                }
                onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                placeholder="Syötä y.tunnus…"
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  borderRadius: 10,
                  border: '1px solid rgba(255,255,255,0.15)',
                  background: 'rgba(255,255,255,0.06)',
                  color: '#fff',
                  outline: 'none',
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleAddBusinessId();
                  }
                  if (e.key === 'Escape') {
                    setShowSuggestions(false);
                  }
                }}
              />
              <button
                style={{
                  borderRadius: 12,
                  padding: '9px 12px',
                  fontWeight: 600,
                  cursor: selectedForm?.businessId ? 'not-allowed' : 'pointer',
                  background: 'transparent',
                  color: selectedForm?.businessId
                    ? 'rgba(216,232,255,0.5)'
                    : '#d8e8ff',
                  border: `1px solid ${
                    selectedForm?.businessId
                      ? 'rgba(216,232,255,0.1)'
                      : 'rgba(216,232,255,0.25)'
                  }`,
                  boxShadow: 'none',
                  opacity: selectedForm?.businessId ? 0.5 : 1,
                }}
                onClick={() =>
                  !selectedForm?.businessId && handleAddBusinessId()
                }
                disabled={!!selectedForm?.businessId}
              >
                Lisää
              </button>
            </div>

            {/* Suggestions Dropdown */}
            {showSuggestions && filteredBusinesses.length > 0 && (
              <SuggestionField
                props={{ filteredBusinesses, handleSuggestionClick }}
              ></SuggestionField>
            )}
          </div>

          <div>
            <label
              style={{
                display: 'block',
                marginBottom: '0.5rem',
                marginTop: '12px',
              }}
            >
              Julkaistu tälle yritykselle:
            </label>
            {selectedForm &&
            selectedForm.businessId &&
            selectedForm?.businessId.length !== 0 ? (
              <ul>
                <li style={{ marginBottom: '0.25rem' }}>
                  {selectedForm.businessId}{' '}
                  <button
                    onClick={() =>
                      handleRemoveBusinessId(selectedForm.businessId)
                    }
                    style={removeButtonStyle}
                  >
                    Poista
                  </button>
                </li>
              </ul>
            ) : (
              <p>Ei julkaistu millekkään yritykselle.</p>
            )}
          </div>

          <Button
            variant="contained"
            color="primary"
            onClick={onUpdateFormEditorThunk}
          >
            Tallenna
          </Button>
        </main>
      )}
    </>
  );
};

const removeButtonStyle = {
  marginLeft: '1rem',
  fontSize: '0.8rem',
  color: '#c00',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
};
